//import React, { useState } from "react";
//import { useContext } from "react";
//import { useNavigate } from 'react-router-dom';

//import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../../Context';


export default function ConfirmationModal ({modalId, headerText, messageText, confirmButtonText, Action, danger=false}) {
  //const [headerText, setHeaderText] = useState(false);
  //const [messageText, setMessageText] = useState(false);
  //const [confirmButtonText, setConfirmButtonText] = useState(false);
  //const [action, setAction] = useState(false);
  //const [danger, setDanger] = useState(false);

  //const media_url = useContext(MEDIA_URL);
  //const api_url = useContext(API_URL);
  //const token = useContext(AUTH_TOKEN);
  //const navigate = useNavigate();
  console.log(messageText);

  function ParagraphText({text}){
    return(
      <p className="m-4 fs-5 text-center"  style={{'fontWeight': '500'}}>{text}</p>    
    );
  }

  let rows = [];
  for (let i in messageText) {
    console.log(messageText[i]);

    rows.push(
      <ParagraphText 
        text={messageText[i]}
      />
    );
  }

  return(
    <div 
        className="modal fade modal-xs" 
        id={modalId} 
        tabIndex="-1" 
        aria-labelledby={modalId + "Label"} 
        aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-scrollable modal-xs">
        <div className="modal-content">
          <div className="modal-header bg-light">
            <h2 className="modal-title fs-5" id={modalId + "Label"}>{headerText}</h2>
            <button type="button" className="btn-close me-3" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            {rows}
          </div>
          <div className="modal-footer justify-content-between">
            <button 
              type="button" 
              className="btn btn-secondary lk-bootstrap-button" 
              data-bs-dismiss="modal">
              Отмена
            </button>

            {danger === true?
              <button 
                type="button" 
                className="btn btn-danger lk-bootstrap-button" 
                data-bs-dismiss="modal" 
                aria-label="Close" 
                onClick={() => Action()}
              >
                {confirmButtonText}
              </button>
            :
              <button 
                type="button" 
                className="btn lk-button lk-bootstrap-button" 
                data-bs-dismiss="modal" 
                aria-label="Close" 
                onClick={() => Action()}
              >
                {confirmButtonText}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  );
}